import { Link } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/manga';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-display text-accent-400 mb-3">{siteInfo.name}</h3>
            <p className="text-sm text-background-300 leading-relaxed">
              {siteInfo.description}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-3">热门分类</h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap"
                >
                  {cat.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-3">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap">
                品牌介绍
              </Link>
              <Link to="/about" className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap">
                联系我们
              </Link>
              <span className="text-sm text-background-400 mt-2">
                邮箱：{siteInfo.email}
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <p className="text-xs text-background-400">
            本站内容仅供学习交流，请支持正版
          </p>
        </div>
      </div>
    </footer>
  );
}